import React from 'react'
import { OverContainer, ContentSubTitle, ContentCards } from './styles'
import {
    TypographyContent,
    TypographyTitle,
} from 'src/components/common/Typography/typography'
import { KnowOurSecretsLabels } from 'src/constants'
import { MapSecrets } from './mapSecrets'
import { useAnimation } from 'src/hook'
import { scaleVariantTitle } from 'src/theme/animations/swipeIn'
import { useTranslations } from 'src/provider/LocaleProvider'

export const KnowOurSecrets = () => {
    const t = useTranslations()
    const { KnowOurSecretsContent } = KnowOurSecretsLabels()
    const { control, ref } = useAnimation({ initialSpriteIdTitle: 2 })

    return (
        <OverContainer paddingTop={'titlle'} paddingBottom={'titlle'} ref={ref}>
            <TypographyTitle
                variant={'h1'}
                fontSize={['xxxlarge', 'xxxlarge', 'xxxlarge', 'titlle']}
                fontWeight={600}
                initial="hidden"
                animate={control}
                variants={scaleVariantTitle}
            >
                {t('knowOurSecrets.title')}
            </TypographyTitle>
            <ContentSubTitle
                paddingBottom={'xxxmedium'}
                initial="hidden"
                animate={control}
                variants={scaleVariantTitle}
            >
                <TypographyContent
                    variant={'h2'}
                    fontSize={['xsmall', 'xsmall', 'xxsmall', 'xxxsmall']}
                    fontWeight={400}
                >
                    {t('knowOurSecrets.content')}
                </TypographyContent>
            </ContentSubTitle>
            <ContentCards paddingTop={'xlarge'}>
                {KnowOurSecretsContent.map((secrets) => {
                    return <MapSecrets key={secrets.id} {...secrets} />
                })}
            </ContentCards>
        </OverContainer>
    )
}
